var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.9062 2c0 .41421.3358.75.75.75h3.5331l-7.4393 7.4393v-2.1893c0-.41421-.3358-.75-.75-.75s-.75.33579-.75.75v4c0 .4142.3358.75.75.75h4c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75h-2.1893l7.4393-7.43934v3.53309c0 .41421.3358.75.75.75s.75-.33579.75-.75v-5.34375c0-.41421-.3358-.75-.75-.75h-5.3438c-.4142 0-.75.33579-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.7516 7.43034c.0454 1.19935 1.0296 2.15836 2.2388 2.16339.0096.72607.0096 1.52497.0096 2.40627 0 4.714 0 7.0711-1.4645 8.5355-1.4644 1.4645-3.8215 1.4645-8.5355 1.4645-4.71405 0-7.07107 0-8.53553-1.4645-1.46447-1.4644-1.46447-3.8215-1.46447-8.5355 0-4.71405 0-7.07107 1.46447-8.53553 1.46446-1.46447 3.82148-1.46447 8.53553-1.46447.8813 0 1.6802 0 2.4063.00957.005 1.20927.964 2.19341 2.1634 2.23879l-2.6229 2.62286c-.3896-.67044-1.1155-1.12122-1.9468-1.12122-1.2426 0-2.25 1.00736-2.25 2.25v4c0 1.2426 1.0074 2.25 2.25 2.25h4c1.2426 0 2.25-1.0074 2.25-2.25 0-.8313-.4508-1.5572-1.1212-1.9468z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLeaderboard);
export default __webpack_public_path__ + "static/media/expand_leaderboard.e613a2dafc3bdc1d422f9b03501b921d.svg";
export { ForwardRef as ReactComponent };